<template>
  <div
    v-if="isShow"
    class="order-action"
  >
    <button
      v-if="isShowCancle"
      class="action-cancel"
      v-t="'order.cancel'"
      @click="handleCancel"
    />
    <div
      v-if="isShowActivate"
      class="action-activate"
    >
      <mm-button
        type="primary"
        :class="{ disabled: !isCanActivate }"
        v-t="'order.activate'"
        :loading="isRequesting"
        style="width: 120px"
        @click="handleOrderActivate"
      />
      <div
        class="activate-tips"
        v-if="!isCanActivate"
      >
        {{ detail.activation_reason }}
      </div>
    </div>
    <div
      v-if="isCanShare"
      class="action-share"
      v-t="'order.share'"
    />
    <WeChatModal
      :visible.sync="showWeChatModal"
      :order-id="this.orderId"
      :client-id="this.detail.client_id"
      @onClose="handleCloseWeChatModal"
    />
  </div>
</template>
<script>
  import { mapState, mapGetters, mapActions } from 'vuex'
  import { ORDER_STATUS_COMPLETE } from '@utils/constants'
  import OrderApi from '@api/order'
  import WeChatModal from './WeChatModal'

  export default {
    name: 'OrderDetailAction',
    data () {
      return {
        isRequesting: false,
        showWeChatModal: false,
      }
    },
    components: {
      WeChatModal
    },
    computed: {
      ...mapState('order', {
        detail: state => state.detail,
        invoiceFlag: state => state.invoiceFlag
      }),
      ...mapGetters('order', ['isInvoiceEmpty']),
      ...mapGetters('main', ['isMiniProgram', 'isTaiwanClient']),
      verifyStatus () {
        return this.detail.verification_status
      },
      orderId () {
        return this.$route.params.id
      },
      isShow () {
        // 显示底部操作
        // 取消订单、激活订单、分享订单只要有一个满足就显示
        return this.isShowCancle || this.isShowActivate || this.isCanShare
      },
      isShowCancle () {
        if (this.isTaiwanClient) {
          // 台湾客户不显示取消订单按钮
          return false
        }

        // 取消订单按钮
        // 1，未完成的订单
        return this.detail.status != ORDER_STATUS_COMPLETE
      },
      isShowActivate () {
        return false;
      },
      isShowActivateOld () {
        // 显示激活按钮
        // 1，完成订单
        // 2，新签订单
        // 3. 是否所有的产品都已经激活 0 未激活
        const isComplete = this.detail.status == ORDER_STATUS_COMPLETE
        const isNew = this.detail.activation_flag > 0
        const isReleased = this.detail.product_list.every(item => Number(item.status) === 0)
        // erp商品为product_id为25，26，29，30的产品，erp产品status为0，则展示激活按钮
        const ERP_IDS = [25, 26, 29, 30]
        const isErpReleased = this.detail.product_list.some(item => ERP_IDS.includes(Number(item.product_id)) && Number(item.status) === 0)
        const released = isErpReleased || isReleased
        return isComplete && isNew && released
      },
      isCanActivate () {
        // 是否可以激活订单

        // activation_flag 等于1才可以激活
        // // 1，发票不为空
        // const isInvoiceNotEmpty = !this.isInvoiceEmpty
        // // 2，已提交企业认证
        // const hasSubmitVerification = this.verifyStatus > VERIFY_STATUS_NONE

        // return isInvoiceNotEmpty && hasSubmitVerification
        return this.detail.activation_flag == 1
      },
      // activateErrorMsg () {
      //   if (this.verifyStatus === VERIFY_STATUS_NONE) return this.$t('order.authError')
      //   if (!this.invoiceFlag) return this.$t('order.postError')
      //   return ''
      // },
      isCanShare () {
        // 小程序显示分享
        return this.isMiniProgram
      }
    },
    methods: {
      ...mapActions('order', ['fetchOrderDetail']),
      async handleOrderActivate () {
        if (!this.isCanActivate) return
        if (this.isRequesting) return
        const is_crm_product = Number(this.detail.is_crm_product) === 1
        if (is_crm_product) {
          this.showWeChatModal = true
        } else {
          this.isRequesting = true
          await OrderApi.editOrderActivate({
            order_id: this.orderId
          })
          this.fetchOrderDetail()
          this.isRequesting = false
          this.$message.success(this.$t('order.activateSuccess'))
        }
      },
      async handleCancel () {
        if (this.isRequesting) return
        this.isRequesting = true
        await OrderApi.cancelOrder({
          order_id: this.orderId
        })
        if (this.isMiniProgram) {
          window.wx.miniProgram.navigateTo({
            url: '/pages/order/list/list'
          })
        } else {
          this.$router.push(`/order`)
        }
        this.isRequesting = false
      },
      handleCloseWeChatModal () {
        this.showWeChatModal = false
        this.fetchOrderDetail()
      }
    }
  }
</script>

<style lang="scss">
  .order-action{
    display: flex;
    align-items: center;
    height: 94px;
    padding: 0 40px;
    border-top: 2px solid #D9D9D9;
    @include layout--mobile{
      padding: 0 18px;
    }
  }
  .action-cancel,
  .activate-button{
    @extend %base-button;
    width: 88px;
    height: 34px;
    user-select: none;
    &.disabled{
      background: #909090;
    }
  }
  .action-activate{
    display: flex;
    align-items: center;
  }
  .activate-button{
    margin-right: 18px;
  }
  .activate-tips{
    font-weight: 600;
    color: #E4443E;
  }
  .action-share{
    margin-left: auto;
  }
</style>

